/**
 * The canonical interest timeline event direction vocabulary. This `as const` tuple is the single
 * source of truth so the zod mirror in `src/context/` can build `z.enum(...)` from it and cannot
 * drift from the pure engine types.
 */
export const INTEREST_TIMELINE_EVENT_DIRECTIONS = ['inbound', 'outbound', 'internal'] as const;
